<template>
    <div class="ma-4">
      <StaffNav class="hideOnPrint" />
      <v-row class="hideOnPrint">
        <v-col cols="12" lg="3" xl="2">
          <StaffSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-data-table
            :headers="headers"
            :items="items"
            sort-by="Date"
            sort-desc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Raises"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Raises</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <span class="" v-if="isLoadingButtons">
                  Rate:
                  <v-progress-circular
                    indeterminate
                    color="secondary"
                    class="ms-2 my-auto"
                    :size="20"
                    :width="1"
                  ></v-progress-circular>
                </span>
                <span v-else>Rate: ${{ currentRate }}</span>
                <span class="ms-1" v-if="rateType && !isLoadingButtons">({{ rateType }})</span>
                <v-tooltip v-else-if="rateType == null && isLoadingButtons == false" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge
                      dot
                      color="warning"
                    >
                      <v-btn
                        class="ms-2"
                        color="grey darken-3"
                        icon
                        x-small
                        elevation="0"
                        v-bind="attrs"
                        v-on="on"
                        @click="$router.push({
                          path: `/users/update-user/${$store.state.staff.staff._id}`,
                          query: { newUser: 'false' }
                        });"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-badge>
                  </template>
                  <span>Update the rate/pay type.</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                  :disabled="isLoadingButtons"
                ></v-text-field>                         
  
                <v-spacer></v-spacer>
                <!-- <report-list-actions
                  :reportOptions="reportOptions"
                  :downloadFilename="reportListFilename"
                ></report-list-actions> -->
  
                <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" @click="showAdd" :loading="isLoadingButtons" :disabled="isLoadingButtons">
                  <v-icon left>add</v-icon>
                  Add Raise
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
            
            <template v-slot:item.Raise="{ item }">
              <span class="me-8">{{ item.Raise }}</span>
              <v-chip
                v-if="currentRaise._id === item._id"
                color="success"
                dark
                small
              >
                latest raise
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="onViewItem(item)" color="primary" :disabled="isLoadingButtons">
                mdi-eye
              </v-icon>
  
              <v-icon v-if="!isAuditorRole" small @click="confirmDelete(item)" color="error" :disabled="isLoadingButtons"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="fetchItems"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <Foot class="hideOnPrint" />
    </div>
  </template>
  
  <script>
  /*eslint-disable */
  import axios from 'axios';
  import { mapState, mapActions } from "vuex";
  import StaffNav from "@/components/StaffNav";
  import StaffSide from "@/components/StaffSide";
  import Foot from "@/components/Footer";
  import renameFileHelper from "@/mixins/renameFileHelper";
  import ReportListActions from '@/components/Report/ReportListActions.vue'
  
  const url = require("../../../client_config/config").url;

  export default {
    mixins: [renameFileHelper],
    components: {
      StaffNav,
      StaffSide,
      Foot,
      ReportListActions
    },
    data: function () {
      return {
        headers: [
          {
            text: "Raise Date",
            align: "start",
            sortable: true,
            value: "RaiseDate",
          },
          // { text: "Type of Healthcare", value: "TypeOfHealthCare" },
          { text: "Raise Amount", value: "Raise" },
          // { text: "", value: "status", sortable: false },
          { text: "", value: "actions", sortable: false },
        ],
        search: "",
        // bonuses: [],
        employeeID: this.$route.params.employeeID,
        isPrintingTable: false,

        currentRaise: {},
        currentRate: "",
        rateType: "",
        
        isLoadingButtons: true,
      };
    },
  
    computed: {
      ...mapState("raises", ["items", "isLoading"]),
  
      staffName() {
        return this.$store.state.users.user.Name;
      },
  
      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.employeeID
        )
      },
  
      employeeName() {
        return this.selectedEmployee.Name ?? this.staffName
      }, 
    
      reportOptions() {
        return { 
          query: {
            name: this.employeeName,
          },
          endpoints: `garnishments/printList/${this.employeeID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Staff Raises`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
    },
    created() {
      this.refreshPageData();
    },
    methods: {
      ...mapActions("raises", ["getItems", "deleteItem", "downloadItem"]),
      ...mapActions(
        "staff", [
          "getStaff"
        ]
      ),
  
      onViewItem(item) {
        this.$router.push({
          path: `/raises/${this.employeeID}/edit`,
          query: { id: item._id, new: false },
        });
      },
  
      showAdd() {
        this.$router.push({
          path: `/raises/${this.employeeID}/add`,
        });
      },
  
      async confirmDelete(item) {
        const id = item._id;
        const data = item;
        
        if (confirm("Are you sure you want to delete this record?")) {
          const response = await this.deleteItem({ id, userEmail: this.selectedEmployee.Email, data});
          
          if (response.status === 200) {
            this.refreshPageData()
          }
        }
      },
  
      fetchItems() {
        this.getItems(this.$store.state.staff.staff.Email);
      },

      async getCurrentRaise () {
        this.currentRaise = await axios.get(`${url}/raises/getStaffLatestRaise/${this.$store.state.staff.staff.Email}/${this.$store.state.staff.staff._id}`).then(res => {
          const data = res.data != null ? res.data : null;
          this.isLoadingButtons = false;

          return data;
        });
        
        this.currentRate = this.$store.state.staff.staff.Rate;
        // this.currentRate = parseFloat(this.currentRaise.Rate) + parseFloat(this.currentRaise.Raise);
        // this.currentRate = isNaN(this.currentRate) ? parseFloat(this.currentRaise.Rate) : this.currentRate;
        this.rateType = this.$store.state.staff.staff.RateType
      },

      refreshPageData () {
        this.isLoadingButtons = true;

        this.getStaff(this.employeeID).finally(() => {
          setTimeout(() => {
            this.fetchItems()
            this.getCurrentRaise()
          }, "2000");
        })
      }
    },
  };
  </script>
  
  <style>
  
  #printItem {
    display: none;
  }
  
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  
  @media print {
    #printItem {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
      display: none;
      border: none;
    }
  
    @page {
      margin: 0;
    }
    body {
      margin: 1.6cm;
    }
  }
  </style>
  